import * as React from 'react';
import { LocalizedText } from 'bernie-l10n';
import { UitkIcon } from 'uitk-react-icons';

export interface FooterProps {
  className?: string;
}

export const Footer: React.FunctionComponent<FooterProps> = ({ className = '' }) => {
  const footerClassNames = ['uitk-cell', 'uitk-card-separator-top', 'listing__content--footer', 'all-x-padding-three', 'all-y-padding-two'];

  return (
    <footer className={`${footerClassNames.join(' ')} ${className}`}>
      <div className="uitk-grid uitk-type-300 uitk-type-medium pwa-theme--link">
        <div className="uitk-cell all-cell-1-2 all-cell-align-middle all-cell-fill">
          <LocalizedText message="hotels.searchResults.meta.listing.footer" />
        </div>
        <div className="uitk-cell all-cell-1-2 all-cell-align-middle all-cell-shrink">
          <UitkIcon name="chevron_right" />
        </div>
      </div>
    </footer>
  );
};
